export default "/fr/_next/static/assets/images/blick-tv-logo.160f3b2da4e72796ddb24abf3f74fa5c.svg";